import { useState } from "react";

export function CopyButton({ text, label = "Copy" }: { text: string; label?: string }) {
  const [copied, setCopied] = useState(false);
  return (
    <button
      type="button"
      onClick={async () => {
        try {
          await navigator.clipboard.writeText(text);
          setCopied(true);
          setTimeout(() => setCopied(false), 1200);
        } catch {
          // clipboard may be unavailable; ignore
        }
      }}
      className="rounded-md px-2 py-1 text-xs font-medium transition-colors"
      style={{ background: "var(--nl2s-surface-raised)", color: "var(--nl2s-text-muted)" }}
    >
      {copied ? "Copied ✓" : label}
    </button>
  );
}
